module.exports = __webpack_public_path__ + "static/media/default-avatar.907af9af.png";